// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getToasterOptions = (options?: { [key: string]: any }) => {
  return {
    autoClose: 4000,
    hideProgressBar: true,
    ...options,
  };
};
